.diary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* On a desktop the day card sits under the chart at a readable width rather
 * than stretching across the whole column. */
@media (min-width: 720px) {
  .diary > :last-child {
    max-width: 520px;
  }
}
